__turbopack_context__.v({
  "paginationContainer": "showcase-module-scss-module__94umYG__paginationContainer",
});
